module.exports = __webpack_public_path__ + "img/pijl-links-wit.d9f6586987c8b8806aa0811527f3d4b6.svg";